import router from './router'
  
router.beforeEach((to, from, next) => {
  // 设置界面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  if (from.path == "/") {
    to.meta.headerBack = true;
  }
  // 切换界面背景颜色
  if (to.meta.backdrop) {
    document.body.style.backgroundColor = "#F5F5F5";
  } else {
    document.body.style.backgroundColor = "#FFFFFF";
  }
  next();
})
